export default __webpack_public_path__ + "static/media/sale-button.1b83dc7f.jpg";